var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.queryType === 'user' && _vm.centerId)?_c('user-portrait',{attrs:{"centerId":_vm.centerId}}):_vm._e(),(_vm.queryType === 'goods' && _vm.goodId)?_c('goods-portrait',{attrs:{"goodId":_vm.goodId}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }